import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as StoryActions from "../../data/stories/StoryActions";

import StoryCard from './StoryCard';

const mapStateToProps = (state, ownProps) => ({
    projects: _.filter(state.projects, project => ownProps.story.projects.includes(project.id))
});

const mapDispatchToProps = {
    removeStory: StoryActions.removeStory,
    duplicate: StoryActions.duplicate,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryCard);
